module.exports = __webpack_public_path__ + "banner01.jpg?7d4b69cdd6e265a0a2ba5e4ed17a05e4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner01.jpg
// module id = 61
// module chunks = 0